import React from 'react';
import './InputComponent.css';

const InputComponent = ({
    disabled = false,
    name,
    placeholder,
    ref = null,
    value,
    onChange,
    error,
    type = 'text',
    maxLength,
    onBlur,
    multiline = false,
    style = {},
    ...props
}) => {

    const MAX_ROWS = 3;
    const MIN_ROWS = 1;

    const handleInput = (e) => {
        const textarea = e.target;

        textarea.rows = MIN_ROWS;

        const lineHeight = 24; // adjust if your font size differs
        const currentRows = Math.floor(textarea.scrollHeight / lineHeight);

        if (currentRows >= MAX_ROWS) {
            textarea.rows = MAX_ROWS;
            textarea.style.overflowY = 'auto';
        } else {
            textarea.rows = currentRows;
            textarea.style.overflowY = 'hidden';
        }

        handleValueChange(e);
    };

    const handleValueChange = (e) => {
        let value = e.target.value;
        if (type === 'number' && maxLength && value.length > maxLength) {
            value = value.slice(0, maxLength);
        } else {
            onChange && onChange(e);
        }
    };

    return (
        <div className="input-group">
            {multiline ?
                <textarea
                    disabled={disabled}
                    name={name}
                    placeholder={placeholder}
                    ref={ref}
                    type={type}
                    value={value}
                    onChange={handleInput}
                    onBlur={onBlur}
                    style={style}
                    rows={1}
                    maxLength={maxLength}
                />
                : <input
                    disabled={disabled}
                    name={name}
                    placeholder={placeholder}
                    ref={ref}
                    type={type}
                    value={value}
                    onChange={handleValueChange}
                    onBlur={onBlur}
                    maxLength={maxLength}
                    style={style} // Keep the flexibility to pass inline styles if needed
                    className={type === 'number' ? 'no-spinner' : ''}
                />}
            {error && <span className="error-text">{error}</span>}
        </div>
    );
};

export default InputComponent;
